'use strict';

angular.module('cgmemApp')
  .config(['$stateProvider', function ($stateProvider) {
    $stateProvider
      .state('authenticated', {
        //url: '/account',
        templateUrl: 'app/authenticatedWrap/authenticatedWrap.html',
        controller: 'AuthWrapCtrl',
				abstract: true
      });
  }]);